// extracted by mini-css-extract-plugin
module.exports = {"newsroom-banner-box":"f","newsroomBannerBox":"f","newsroomBannerLeft":"g","newsroomBannerRight":"h"};